<template>
  <v-container>
    <v-row>
      <v-col stretch>
        <v-breadcrumb
          v-if="$route.name === 'createClient'"
          :items="breadcrumbCreateClientItems"
          :mobile="breadcrumbMobileCreateItem"
        ></v-breadcrumb>
        <v-breadcrumb
          v-if="$route.name === 'editClient'"
          :items="breadcrumbEditClientItems"
          :mobile="breadcrumbMobileEditItem"
        ></v-breadcrumb>
      </v-col>
    </v-row>
    <v-row>
      <v-col stretch>
        <v-title-bar v-if="$route.name === 'createClient'" :title="$t('titles.createClient')">
          <v-button class="wrap-btn" primary @click.native="$eventbus.$emit('submitClient', true)">{{
            $t("actions.createClient")
          }}</v-button>
        </v-title-bar>
        <v-title-bar v-if="$route.name === 'editClient'" :title="$t('titles.editClient')">
          <v-button class="wrap-btn" primary @click.native="$eventbus.$emit('submitClient', false)">{{
            $t("actions.save")
          }}</v-button>
        </v-title-bar>
      </v-col>
    </v-row>
    <create-edit-client-form
      v-if="isReady"
      :edit="$route.name === 'editClient'"
      @afterCreate="
        (client) => {
          $goTo('Client', { uid: client.uid });
        }
      "
      @afterEdit="
        (client) => {
          $goTo('Client', { uid: client.uid });
        }
      "
    ></create-edit-client-form>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import CreateEditClientForm from "./forms/CreateEditClientForm";

export default {
  name: "FormClient",
  components: { CreateEditClientForm },
  data() {
    return {
      isReady: false,
      breadcrumbCreateClientItems: [
        {
          label: this.$t("menus.clients"),
          route: { name: "Clients" },
        },
        {
          label: this.$t("menus.createClient"),
          active: true,
        },
      ],
      breadcrumbEditClientItems: [
        {
          label: this.$t("menus.clients"),
          route: { name: "Clients" },
        },
        {
          label: "",
          route: { name: "Client", params: { uid: "" } },
        },
        {
          label: this.$t("menus.editClient"),
          active: true,
        },
      ],
      breadcrumbMobileCreateItem: {
        label: this.$t("menus.clients"),
        route: { name: "Clients" },
      },
      breadcrumbMobileEditItem: {
        label: "",
        route: { name: "Client", params: { uid: "" } },
      },
    };
  },
  created() {
    if (this.$route.name === "editClient") {
      this.getClient({ client: this.$route.params.uid }).then(() => {
        this.breadcrumbEditClientItems[1].label = this.$h.formatName(this.currentClient);
        this.breadcrumbEditClientItems[1].route = {
          name: "Client",
          params: { uid: this.currentClient.uid },
        };
        this.breadcrumbMobileEditItem.label = this.$h.formatName(this.currentClient);
        this.breadcrumbMobileEditItem.route = {
          name: "Client",
          params: { uid: this.currentClient.uid },
        };
        this.getClientTags({
          client: this.$route.params.uid,
          per_page: "100",
        }).then(() => {
          this.isReady = true;
        });
      });
    } else {
      this.isReady = true;
    }
  },
  methods: {
    ...mapActions(["getClient", "getClientTags"]),
  },
  computed: {
    ...mapGetters({
      teams: "auth_get_teams",
      currentClient: "clients_get_current_client",
      currentClientTags: "clients_get_current_client_tags",
    }),
  },
};
</script>
